<template>
  <v-card>
    <v-card-title class="pb-0" v-if="show_load_more">
      <v-flex class="pl-8" sm4>
        <v-autocomplete
            :items="serviceProviderPurposes"
            @change="getData"
            clearable
            flat
            item-text="purpose"
            item-value="id"
            label="Filter by Purpose"
            outlined
            solo
            v-model="filters.purpose"
        />
      </v-flex>
      <v-flex sm4>
        <v-autocomplete
            :items="years"
            @change="getData"
            class="ml-2"
            clearable
            flat
            label="Filter by Year"
            outlined
            solo
            v-model="filters.year"
        />
      </v-flex>
    </v-card-title>
    <v-card-text class="py-0">
      <v-timeline align-top dense>
        <v-timeline-item
            color="primary"
            icon="mdi-check"
            :key="i"
            fill-dot1
            v-for="(item, i) in history"
        >
          <v-layout pt-1>
            <v-flex xs5 class="d-flex">
              <h4 class="timeline-title-blue">{{ item.purpose.purpose }}</h4>
              <span class="mx-2" style="font-size: 11px;">at</span>
              <h5 class="timeline-date ">{{ item.created_at }}</h5>
            </v-flex>
            <v-flex xs7>
            </v-flex>
          </v-layout>
          <v-layout style="color: black;">
            <v-icon>mdi-map-marker</v-icon> {{item.provider.name}}
          </v-layout>
        </v-timeline-item>
      </v-timeline>
    </v-card-text>
    <v-card-actions @click="loadMoreItem" style="justify-content: center" v-if="loadMore">
      <v-btn :loading="history_loading" color="primary" text>Load more</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {mapGetters} from "vuex";
export default {
  name: "TravellerScanHistory",
  props: ['history', 'show_load_more', 'editable'],
  data() {
    return {
      trackId: null,
      loading: false
    }
  },
  methods: {
    loadMoreItem() {
      this.$store.dispatch('TravellerSingle/getScanHistory', null)
    },
    getData() {
      this.$store.dispatch('TravellerSingle/getScanHistory', 'data')
    },
    view(submission_no) {
      window.location.href = '/admin/system/visa-requests/view/' + submission_no
    },
  }
  ,
  computed: {
    ...mapGetters('TravellerSingle', ['scan_history_loading', 'filters']),
    ...mapGetters("AuthUser", ["user"]),
    ...mapGetters("ServiceProvider", ["serviceProviderPurposes"]),
    loadMore() {
      return (!!this.$store.state.TravellerSingle.scan_next_page_url && this.show_load_more);
    },
    years() {
      let end = new Date().getFullYear();
      return Array(end - 2013).fill().map((_, idx) => 2014 + idx);
    }
  },
  mounted() {
    this.$store.dispatch('ServiceProvider/getAllServiceProviderPurpose')
  }
}
</script>

<style scoped>
.timeline-title {
  color: black;
}

.timeline-title-blue {
  color: dodgerblue;
}

</style>
